import * as React from 'react'

import { useSiteConfig } from '@thg-commerce/enterprise-core'
import { withESI } from '@thg-commerce/enterprise-esi'
import { SponsoredAdsBanner } from '@thg-commerce/enterprise-components/SponsoredAds'

import { BaseWidgetProps } from '../types'

const SponsoredAdsESIBanner = withESI(SponsoredAdsBanner, 'sponsoredAds-banner')

export const FlagshipRenderer = (props: BaseWidgetProps & { id: string }) => {
  const { enableSponsoredAds } = useSiteConfig()

  return enableSponsoredAds ? (
    <SponsoredAdsESIBanner path={props.pagePath} id={props.id} />
  ) : null
}
